@if (!!viewModel) {
  <div class="row pb-1">
    <div class="col-10">
      @if (transporttidApplicable) {
        <fieldset>
          <rask-label size="12" class="ps-0 mb-0">Totalt transporttidsspann</rask-label>
          <div class="svea-text">{{viewModel.minTransportdatumBeraknatFrom | date: 'yyyy-MM-dd'}} -
          {{viewModel.maxTransportdatumBeraknatTom | date: 'yyyy-MM-dd'}}</div>
        </fieldset>
      }
    </div>
    <div class="col-2">
      <rask-menu-button [template]="tpl" #menu>
      </rask-menu-button>
      <ng-template #tpl>
        <div class="menu-btn-container">
          <rask-action-button
            class="col-12"
            icon="fas fa-sync-alt"
            aid="button-uppdatera"
            [disabled]="!canMergeDestineringsalternativ"
          (click)="mergeAllDestineringsalternativ()">Uppdatera destineringsalternativ</rask-action-button>
          @if (hasRaskVo) {
            <rask-action-button
              class="col-12"
              icon="fas fa-sync-alt"
              aid="button-uppdatera-viol"
              [disabled]="!canUpdateViol"
            (click)="updateFromViol()">Uppdatera från regelverk</rask-action-button>
          }
          @if (arbetsorder.viol3) {
            <rask-action-button
              class="col-12"
              icon="fas fa-pencil-alt"
              aid="button-viol3-justeraMatningsinformation"
            (click)="openViol3JusteraMatningsinformation()">Mätningsinformation</rask-action-button>
          }
          <rask-action-button
            class="col-12"
            icon="fas fa-plus"
            aid="button-destineringsalternativ-manuella"
            [disabled]="!canEditManuellaDestineringsalternativ"
            (click)="openManuellaDestineringsalternativ()">Lägg till
          destineringsalternativ</rask-action-button>
        </div>
      </ng-template>
    </div>
  </div>
  @for (hs of viewModel.arbetsorderHandelssortiment; track hs.id) {
    <div class="container">
      <div class="table-header">
        <rask-header size="4" class="hs-ellipsis">
          {{ hs.handelssortimentNamn }}
        </rask-header>
        <div class="header-right-container ms-auto" nowrap>
          <div class="d-flex h-100">
            @if (transporttidApplicable) {
              <span class="header-right-date">{{ hs.transportdatumBeraknatFrom
                | date: 'yyyy-MM-dd'}} - {{ hs.transportdatumBeraknatTom | date: 'yyyy-MM-dd'}}
              </span>
            }
            @if (hs.beraknaNarmasteIndustri && !arbetsorder.isExternArbetsorder) {
              <rask-icon-button
                (click)="openAvstandNarmasteIndustri(hs)" icon="far fa-ellipsis-v">
              </rask-icon-button>
            }
          </div>
        </div>
      </div>
      <div>
        <div>
          @for (alternativ of hs.destineringsalternativ; track alternativ.id) {
            <div class="content">
              @switch (alternativ.status) {
                @case ('complete') {
                  <ng-container
                    [ngTemplateOutlet]="complete"
                  [ngTemplateOutletContext]="{alternativ: alternativ}"></ng-container>
                }
                @case ('empty') {
                  <ng-container
                    [ngTemplateOutlet]="empty"
                  [ngTemplateOutletContext]="{alternativ: alternativ}"></ng-container>
                }
                @case ('beraknar') {
                  <ng-container
                    [ngTemplateOutlet]="beraknar"
                  [ngTemplateOutletContext]="{alternativ: alternativ}"></ng-container>
                }
              }
              @if (alternativ.isOgiltig) {
                <div class="row validation-message">
                  <rask-validation-message-row message="Saknar försörjningsrad" type="error">
                  </rask-validation-message-row>
                </div>
              }
              @if (!!alternativ.alertValidationMessage) {
                <div class="row validation-message">
                  <rask-validation-message-row [message]="alternativ.alertValidationMessage"
                  type="error"></rask-validation-message-row>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
}

<ng-template let-alternativ="alternativ" #complete>
  <div class="row header">
    <div class="col-6 svea-text">
      <span title="{{alternativ.mottagningsplatsnummer}}">
        <div [ngClass]="{ 'inaktiv-text': !alternativ.aktiv }">
          {{ writeMottagningsplats(alternativ) }}
        </div>
      </span>
      @if (!alternativ.aktiv) {
        <rask-info [infoIconSolid]="false" class="destineringsRadInfo">Raden skickas ej
        med virkesordern</rask-info>
      }
    </div>
    <div class="col-3 svea-text ps-0 text-end">
      <div>
        <span
          [ngClass]="{ 'transportavstand-modified': alternativ.isModified, 'transportavstand-not-modified': !alternativ.isModified}">{{alternativ.transportavstand
        | raskKilometer: 0}}</span>
        <rask-icon-button aid="button-edit-avstand_{{alternativ.id }}"
          (click)="editTransportavstand(alternativ)" icon="fas fa-pencil-alt"
          [disabled]="!alternativ.aktiv || (arbetsorder.isExternArbetsorder && !arbetsorder.viol3)">
        </rask-icon-button>
      </div>
    </div>

    <div class="col-2" nowrap>
      @if (validation) {
        <rask-input-number
          aid="input-andel_{{alternativ.id}}"
          unit="%"
          [min]="0"
          [max]="100"
          [disabled]="!canEditAndel || !alternativ.destinerbart"
          [(ngModel)]="alternativ.andel"
          [raskRule]="validation[alternativ.ruleName]"
          raskRuleDisplayType="Container"
          [ruleContainerId]="alternativ.ruleName"
        (change)="onAndelChanged($event, alternativ)"></rask-input-number>
      }
    </div>
    <div class="col-1">
      @if (!arbetsorder.viol3) {
        <rask-icon-button (click)="openKontraktsrader(alternativ)"
          icon="far fa-ellipsis-v">
        </rask-icon-button>
      }
      @if (arbetsorder.viol3) {
        <rask-icon-button (click)="openViol3Destineringsrader(alternativ)"
          icon="far fa-ellipsis-v">
        </rask-icon-button>
      }
    </div>
    <rask-validation-message-container [id]="alternativ.ruleName">
    </rask-validation-message-container>
  </div>
</ng-template>

<ng-template let-alternativ="alternativ" #empty>
  @if (interpretEmptyAsError) {
    <div class="row validation-message">
      <rask-validation-message-row message="Det saknas kundorderrad för handelssortimentet"
      type="error"></rask-validation-message-row>
    </div>
  }
  @if (!interpretEmptyAsError) {
    <div class="row validation-message">
      <rask-validation-message-row message="Kundorderrader är ännu inte hämtade för detta handelssortiment"
      type="warning"></rask-validation-message-row>
    </div>
  }
</ng-template>

<ng-template let-alternativ="alternativ" #beraknar>
  <div class="row header">
    <div class="col-9 svea-text">Beräknar...</div>
  </div>
</ng-template>